

















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Chart, ChartData, ChartOptions, ScriptableScalePointLabelContext } from 'chart.js'
import Pentagon from '@/components/common/atoms/Pentagon.vue'
import Color from '@/mixins/constant/Color.ts'

export type RadarChartRecords = {
  labels: string[]
  total: {
    label: string
    data: number[]
  }
  local: {
    label: string
    data: number[]
  }
}

@Component({
  components: {
    Pentagon,
  },
})
export default class RadarChartSubject extends Vue {
  @Prop()
  chartRecords!: RadarChartRecords
  @Prop()
  labelColors!: string[]
  @Prop({ default: false })
  isStudyModeRecommend!: boolean

  private chartData: ChartData | null = null

  private get styles() {
    // グラフの色設定にCSS変数を渡す方法が見つからないため、ここで定義
    return {
      '--color-total-border': Color.TOTAL_BORDER,
      '--color-total-background': Color.TOTAL_BACKGROUND,
      '--color-local-border': Color.LOCAL_BORDER,
      '--color-local-background': Color.LOCAL_BACKGROUND,
    }
  }

  // 一部のオプションで警告が出るためanyを付けています
  private options: ChartOptions | any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      /**
       * レーダーチャートのオプション一覧
       * https://www.chartjs.org/docs/3.7.1/axes/radial/linear.html
       */
      r: {
        min: 0, // グラフの最小値
        max: this.isStudyModeRecommend ? 300 : 100, // グラフの最大値
        grid: {
          circular: true, // グリッドラインを円形にする
          lineWidth: 2, // グリッドの線の太さ
        },
        pointLabels: {
          font: {
            size: 18, // 教科名のサイズ
            family: '"Noto Sans JP", sans-serif',
          },
          padding: 10,
          color: Color.WHITE, // 教科名の文字色
          backdropColor: (context: ScriptableScalePointLabelContext): string => this.labelColors[context.index], // 教科名の背景色
          backdropPadding: 5,
        },
        ticks: {
          display: false,
          stepSize: this.isStudyModeRecommend ? 50 : 20, // グリッドラインの刻み単位
        },
      },
    },
    plugins: {
      // 凡例の設定
      legend: {
        display: false,
      },
    },
  }

  private mounted() {
    this.chartData = {
      labels: this.chartRecords.labels,
      datasets: [
        {
          label: this.chartRecords.local.label,
          data: this.chartRecords.local.data,
          backgroundColor: this.styles['--color-local-background'],
          borderColor: this.styles['--color-local-border'],
          borderWidth: 3, // 線の幅
          radius: 0, // 頂点の大きさ
        },
        {
          label: this.chartRecords.total.label,
          data: this.chartRecords.total.data,
          backgroundColor: this.styles['--color-total-background'],
          borderColor: this.styles['--color-total-border'],
          borderWidth: 2, // 線の幅
          radius: 0, // 頂点の大きさ
        },
      ],
    }
    new Chart(this.$el.querySelector('.radar-chart-subject__canvas') as HTMLCanvasElement, {
      type: 'radar',
      data: this.chartData,
      options: this.options,
    })
  }
}
